import React from "react";
import { Link, useNavigate } from "react-router-dom";
import ProfileDropdown from "./ProfileDropdown";
import { useSessionContext } from "supertokens-auth-react/recipe/session";


const Navbar = () => {
  const session = useSessionContext();
  

  return (
    <nav className="bg-primary text-white shadow-lg px-8 py-4 flex justify-between items-center">
      {/* Logo/App Name */}
      <div className="font-bold text-2xl text-white tracking-tight">
        <Link to="/" className="text-white hover:text-accent transition duration-300">AI T-Shirt</Link>
      </div>

      {/* Nav Links */}
      <div className="flex items-center space-x-6">
        <Link
          to="/design"
          className="text-gray-200 font-semibold hover:text-white transition duration-300"
        >
          Generate
        </Link>
        <Link
          to="/products"
          className="text-gray-200 font-semibold hover:text-white transition duration-300 tour-products-nav"
        >
          Products
        </Link>
        <Link
          to="/gallery"
          className="text-gray-200 font-semibold hover:text-white transition duration-300 tour-gallery-nav"
        >
          Gallery
        </Link>
        <Link
          to="/mockups"
          className="text-gray-200 font-semibold hover:text-white transition duration-300 tour-mockups-nav"
        >
          Mockups
        </Link>
        <Link
          to="/orders"
          className="text-gray-200 font-semibold hover:text-white transition duration-300 tour-orders-nav"
        >
          Order History
        </Link>
        <Link
          to="/admin"
          className="text-gray-200 font-semibold hover:text-white transition duration-300"
        >
          Admin
        </Link>
        {session.loading === false && session.doesSessionExist && session.accessTokenPayload.roles && (session.accessTokenPayload.roles.includes("admin") || session.accessTokenPayload.roles.includes("facility_printful")) && (
          <Link
            to="/ordermanagement"
            className="text-gray-200 font-semibold hover:text-white transition duration-300"
          >
            Order Management
          </Link>
        )}
        
      </div>

      {/* Profile and Logout */}
      <ProfileDropdown />
    </nav>
  );
};

export default Navbar;
